import { Onboarding, OnboardingWhatsNew } from "@edp-models/onboarding.model";
import { Action } from "@ngrx/store";

export enum EOnboardingActions {
    GetOnboarding = "[Onboarding] Get Onboarding",
    SetOnboarding = "[Onboarding] Set Onboarding",
    GetOnboardingWhatsNew = "[Onboarding] Get Onboarding Whats New",
    SetOnboardingWhatsNew = "[Onboarding] Set Onboarding Whats New",
    SetCompleteOnboarding = "[Onboarding] Set Complete Tour",
    WhatsNewRequestsAPIError = "[Onboarding] WhatsNew Requests API Error",
}

export class GetOnboarding implements Action {
    public readonly type = EOnboardingActions.GetOnboarding;
}

export class SetOnboarding implements Action {
    public readonly type = EOnboardingActions.SetOnboarding;
    constructor(public payload: Onboarding | null) {}
}

export class GetOnboardingWhatsNew implements Action {
    public readonly type = EOnboardingActions.GetOnboardingWhatsNew;
}

export class SetOnboardingWhatsNew implements Action {
    public readonly type = EOnboardingActions.SetOnboardingWhatsNew;
    constructor(public payload: OnboardingWhatsNew | null) {}
}

export class SetCompleteOnboarding implements Action {
    public readonly type = EOnboardingActions.SetCompleteOnboarding;
    constructor(public onboardingId: string, public action: "reading" | "complete" = "complete") {}
}

export class WhatsNewRequestsAPIError implements Action {
    public readonly type = EOnboardingActions.WhatsNewRequestsAPIError;
    constructor(public error: Error) {}
}

export type OnboardingActions =
    | GetOnboarding
    | SetOnboarding
    | GetOnboardingWhatsNew
    | SetOnboardingWhatsNew
    | SetCompleteOnboarding
    | WhatsNewRequestsAPIError;
